import { render, staticRenderFns } from "./PaymentGatewaySelector.vue?vue&type=template&id=71b628d3&scoped=true&"
import script from "./PaymentGatewaySelector.vue?vue&type=script&lang=js&"
export * from "./PaymentGatewaySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b628d3",
  null
  
)

export default component.exports